import React, { useContext, useState } from 'react'
import '../css/checkout.css'
import OrderForm from '../components/OrderForm'
import OrderResume from '../components/OrderResume'
import logo from '../assets/logo.jpg'
import { CartContext } from '../Contexts/CartContext'
import Header from '../components/Header'
import LoadingBox from '../components/LoadingBox'

const Checkout = () => {
  const { cart, transport, box } = useContext(CartContext);

  if (cart.length == 0) window.location.href = "/";

  return (
    <>
      <Header page="checkout" />

      <main className='container'>
        <OrderResume
         cart={cart}
         transport={transport}
         box={box}
        />

        <section className='container__aside'>
          <OrderForm />
        </section>
      </main>
    </>
  )
}

export default Checkout